




import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { cnpjFormat } from '@/helpers/cnpjFormat';

@Component
export default class UiCnpjFormat extends BaseComponent {
  @Prop()
  public cnpj: string;

  public cnpjFormated: string = '';

  @Watch('cnpj')
  public onChangeCnpj(val: string): void {
    this.cnpjFormated = cnpjFormat(val);
  }

  public beforeMount(): void {
    this.cnpjFormated = cnpjFormat(this.cnpj);
  }
}
